import * as R from "ramda";
import * as types from "../constants/action-types";
import initialState from "./initial-state";

export const sessionReducer = R.cond([
    [
        (state, action) => (action.type === types.INITIALIZE_SUCCESS),
        (state, action) => ({
            ...state,
            isInitialized: true,
            error: null
        })
    ],
    [
        (state, action) => (action.type === types.INITIALIZE_FAIL),
        (state, action) => ({
            ...state,
            isInitialized: false,
            error: action.payload.error
        })
    ],
    [
        (state, action) => (action.type === types.LOGIN_SUCCESS),
        (state, action) => ({
            ...state,
            user: action.payload.data,
            isAuthenticated: true,
            error: null
        })
    ],
    [
        (state, action) => (action.type === types.LOGIN_FAIL),
        (state, action) => ({
            ...state,
            user: null,
            isAuthenticated: false,
            error: action.payload.error
        })
    ],
    [
        (state, action) => (action.type === types.LOGOUT_SUCCESS),
        (state) => ({
            ...state,
            user: null,
            isAuthenticated: false,
            error: null
        })
    ],
    [
        (state, action) => (action.type === types.LOGOUT_FAIL),
        (state, action) => ({
            ...state,
            error: action.payload.error
        })
    ],
    [
        (state, action) => (action.type === types.RESET_PASSWORD_SUCCESS),
        (state) => ({
            ...state,
            isPasswordResetSuccessful: true,
            error: null
        })
    ],
    [
        (state, action) => (action.type === types.RESET_PASSWORD_FAIL),
        (state, action) => ({
            ...state,
            isPasswordResetSuccessful: false,
            error: action.payload.error
        })
    ],
    [
        (state, action) => (action.type === types.RESET_PASSWORD_CLEAR),
        (state) => ({
            ...state,
            isPasswordResetSuccessful: null,
            error: null
        })
    ],
    [
        (state, action) => (action.type === types.LOGIN_RESET),
        (state) => ({
            ...state,
            isPasswordResetSuccessful: null,
            user: null,
            error: null
        })
    ],
    [
        R.T,
        state => (state || initialState.session)
    ]
]);